var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphFunctionPositivePsychological(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 10)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.894 60c-1.338 0-2.376-1.328-2.21-2.828 1.232-11.129 9.635-19.74 19.817-19.74 10.183 0 18.585 8.611 19.817 19.74.166 1.5-.872 2.828-2.21 2.828H14.895z",
    fill: "#FF79C9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFBBE4",
    cx: 32.397,
    cy: 27.111,
    rx: 9.341,
    ry: 9.365
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.02 23.898a5.163 5.163 0 0 1 .638 7.289l-9.101 10.798a5.208 5.208 0 0 1-7.321.64 5.163 5.163 0 0 1-.638-7.288L53.7 24.538a5.208 5.208 0 0 1 7.32-.64zM3.98 23.992a5.163 5.163 0 0 0-.638 7.289l9.101 10.798a5.208 5.208 0 0 0 7.321.64 5.163 5.163 0 0 0 .638-7.288L11.3 24.632a5.208 5.208 0 0 0-7.32-.64z",
    fill: "#FFBBE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.811 6.96.667.686a1.916 1.916 0 0 1-.048 2.72l-6.189 5.923a1.916 1.916 0 0 1-2.697-.047l-.667-.685a1.916 1.916 0 0 1 .048-2.721l6.19-5.923a1.916 1.916 0 0 1 2.696.047zM14.742 6.96l-.668.686a1.916 1.916 0 0 0 .048 2.72l6.19 5.923c.76.727 1.963.706 2.696-.047l.668-.685a1.916 1.916 0 0 0-.048-2.721l-6.19-5.923a1.916 1.916 0 0 0-2.696.047zM31.799.006l.967-.002a1.916 1.916 0 0 1 1.92 1.92l-.02 8.538a1.916 1.916 0 0 1-1.912 1.911l-.967.002a1.916 1.916 0 0 1-1.92-1.92l.02-8.538A1.916 1.916 0 0 1 31.799.006z",
    fill: "#5AA0FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphFunctionPositivePsychological);
export default __webpack_public_path__ + "static/media/icons_graph_function_positive_psychological.456879d3b951c32b405e69f138be2096.svg";
export { ForwardRef as ReactComponent };